import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class StreetMerchantImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /street-merchant/config */
  public getStreetMerchantConfig() {
    return this.makeRequest<API.StreetMerchantConfigsArrayModel>(`street-merchant/config`, {
      method: 'GET'
    });
  }

  /** POST /street-merchant/activity */
  public postStreetMerchantActivity(body: {
    userAddress: string;
    tokenAddress: string;
    transactionHash: string;
    amount: number;
  }) {
    return this.makeRequest<API.StreetMerchantActivityModel | undefined>(`street-merchant/activity`, {
      method: 'POST',
      body
    });
  }
}
